import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, formatKES } from "../lib/api";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function Pricing() {
  const [cust, setCust] = useState([]);
  const [emp, setEmp] = useState([]);
  useEffect(() => {
    api.get("/tiers", { params: { audience: "customer" } }).then((r) => setCust(r.data));
    api.get("/tiers", { params: { audience: "employee" } }).then((r) => setEmp(r.data));
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FE]">
      <Navbar />
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 text-center">
          <div className="label-eyebrow mb-3">Plans</div>
          <h1 className="font-display text-5xl font-bold tracking-tight">Choose your tier</h1>
          <p className="text-[#5B6478] mt-4 max-w-xl mx-auto">In Kenyan shillings. Pay monthly or once. Cancel anytime.</p>
        </div>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 mt-14">
          <h2 className="font-display text-2xl font-bold mb-6">For employers</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {cust.map((t, i) => (
              <div
                key={t.id}
                data-testid={`pricing-cust-${t.id}`}
                className={`price-tile flex flex-col ${i === 1 ? "price-tile-popular" : ""}`}
              >
                {i === 1 && <span className="price-tile-ribbon">Popular</span>}
                <div className="font-display font-bold text-xl">{t.name}</div>
                <div className="mt-2 font-display text-3xl font-extrabold text-[#1E3A8A]">{formatKES(t.price)}<span className="text-xs text-[#5B6478] font-normal">/{t.period === "monthly" ? "mo" : "once"}</span></div>
                <ul className="mt-5 space-y-2 text-sm flex-1">
                  {t.features.map((f, j) => <li key={j} className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#1E3A8A] mt-0.5 shrink-0" /> {f}</li>)}
                </ul>
                <Button asChild className="w-full mt-6 bg-[#1E3A8A] hover:bg-[#2E4FB8] text-[#F8F9FE]">
                  <Link to="/signup">Get started</Link>
                </Button>
              </div>
            ))}
          </div>
          <h2 className="font-display text-2xl font-bold mt-16 mb-6">For staff</h2>
          <div className="grid md:grid-cols-3 gap-5">
            {emp.map((t) => (
              <div key={t.id} data-testid={`pricing-emp-${t.id}`} className="price-tile flex flex-col">
                <div className="font-display font-bold text-xl">{t.name}</div>
                <div className="mt-2 font-display text-3xl font-extrabold text-[#1E3A8A]">{formatKES(t.price)}<span className="text-xs text-[#5B6478] font-normal">/{t.period === "monthly" ? "mo" : "once"}</span></div>
                <ul className="mt-5 space-y-2 text-sm flex-1">
                  {t.features.map((f, j) => <li key={j} className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#1E3A8A] mt-0.5 shrink-0" /> {f}</li>)}
                </ul>
                <Button asChild className="w-full mt-6 bg-[#1E3A8A] hover:bg-[#2E4FB8] text-[#F8F9FE]">
                  <Link to="/signup">Sign up</Link>
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
